<template>
  <section
    class="n-section-secondary"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
  >
    <h1 class="tw-w-full">{{ vars.titleText }}</h1>
    <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleTop'" :duration="500" is="div">
      <div class="tw-mt-10 tw-flex tw-w-full tw-flex-col tw-gap-y-10 lg:tw-mt-20">
        <div
          v-for="(branch, index) in branches"
          :key="`branch-${index}`"
          class="tw-grid tw-grid-cols-12 tw-items-center tw-justify-center tw-gap-8 tw-bg-white tw-p-5 tw-pb-10 lg:tw-gap-12"
          style="border-radius: var(--rounded)"
        >
          <div class="tw-col-span-12 lg:tw-col-span-6">
            <nuxt-img :src="branch.photo" class="tw-rounded-xl lg:tw-h-[416px] lg:tw-w-[650px]"></nuxt-img>
          </div>

          <div class="tw-col-span-12 tw-grid tw-grid-cols-12 lg:tw-col-span-6">
            <div v-if="branch.title" class="tw-col-span-12 tw-pb-5">
              <h3>{{ branch.title }}</h3>
            </div>
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <div v-if="branch.address" class="tw-pb-6">
                <h4 class="!tw-text-lg">Address</h4>

                <div style="width: 230px" class="tw-break-words">
                  <p class="tw-mt-2">{{ branch.address }}</p>
                </div>
              </div>
              <div v-if="branch.primary_phone" class="tw-flex tw-flex-col tw-pb-6">
                <h4 class="!tw-text-lg">Phone</h4>

                <a v-if="branch.primary_phone" :href="`tel:${branch.primary_phone}`" class="n-link tw-mt-2">
                  {{ branch.primary_phone }}
                </a>
                <a v-if="branch.secondary_phone" :href="`tel:${branch.secondary_phone}`" class="n-link tw-mt-2">
                  {{ branch.secondary_phone }}
                </a>
              </div>
              <div v-if="branch.primary_email" class="tw-flex tw-flex-col tw-pb-6">
                <h4 class="!tw-text-lg">Email</h4>
                <a
                  v-if="branch.primary_email"
                  :href="`mailto:${branch.primary_email}`"
                  class="n-link tw-mt-2 tw-break-words"
                >
                  {{ branch.primary_email }}
                </a>
                <a
                  v-if="branch.secondary_email"
                  :href="`mailto:${branch.secondary_email}`"
                  class="n-link tw-mt-2 tw-break-words"
                >
                  {{ branch.secondary_email }}
                </a>
              </div>
              <div v-if="branch.primary_email" class="tw-flex tw-flex-col">
                <h4 v-if="branch.facebook || branch.twitter || branch.linkedin || branch.youtube" class="!tw-text-lg">
                  Socials
                </h4>
                <div class="tw-mt-3 tw-flex tw-flex-row">
                  <a
                    v-if="branch.facebook"
                    :href="branch.facebook"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white !tw-p-0"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.33329 8.99967H11L11.6666 6.33301H9.33329V4.99967C9.33329 4.31301 9.33329 3.66634 10.6666 3.66634H11.6666V1.42634C11.4493 1.39767 10.6286 1.33301 9.76196 1.33301C7.95196 1.33301 6.66663 2.43767 6.66663 4.46634V6.33301H4.66663V8.99967H6.66663V14.6663H9.33329V8.99967Z"
                        fill="#11273E"
                      />
                    </svg>
                  </a>
                  <a
                    v-if="branch.twitter"
                    :href="branch.twitter"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white !tw-p-0"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.20004 1.33301H10.8C12.9334 1.33301 14.6667 3.06634 14.6667 5.19967V10.7997C14.6667 11.8252 14.2593 12.8087 13.5342 13.5338C12.809 14.259 11.8255 14.6663 10.8 14.6663H5.20004C3.06671 14.6663 1.33337 12.933 1.33337 10.7997V5.19967C1.33337 4.17417 1.74075 3.19067 2.46589 2.46553C3.19104 1.74039 4.17454 1.33301 5.20004 1.33301ZM5.06671 2.66634C4.43019 2.66634 3.81974 2.9192 3.36965 3.36928C2.91956 3.81937 2.66671 4.42982 2.66671 5.06634V10.933C2.66671 12.2597 3.74004 13.333 5.06671 13.333H10.9334C11.5699 13.333 12.1803 13.0802 12.6304 12.6301C13.0805 12.18 13.3334 11.5695 13.3334 10.933V5.06634C13.3334 3.73967 12.26 2.66634 10.9334 2.66634H5.06671ZM11.5 3.66634C11.7211 3.66634 11.933 3.75414 12.0893 3.91042C12.2456 4.0667 12.3334 4.27866 12.3334 4.49967C12.3334 4.72069 12.2456 4.93265 12.0893 5.08893C11.933 5.24521 11.7211 5.33301 11.5 5.33301C11.279 5.33301 11.0671 5.24521 10.9108 5.08893C10.7545 4.93265 10.6667 4.72069 10.6667 4.49967C10.6667 4.27866 10.7545 4.0667 10.9108 3.91042C11.0671 3.75414 11.279 3.66634 11.5 3.66634ZM8.00004 4.66634C8.8841 4.66634 9.73194 5.01753 10.3571 5.64265C10.9822 6.26777 11.3334 7.11562 11.3334 7.99967C11.3334 8.88373 10.9822 9.73158 10.3571 10.3567C9.73194 10.9818 8.8841 11.333 8.00004 11.333C7.11599 11.333 6.26814 10.9818 5.64302 10.3567C5.0179 9.73158 4.66671 8.88373 4.66671 7.99967C4.66671 7.11562 5.0179 6.26777 5.64302 5.64265C6.26814 5.01753 7.11599 4.66634 8.00004 4.66634ZM8.00004 5.99967C7.46961 5.99967 6.9609 6.21039 6.58583 6.58546C6.21075 6.96053 6.00004 7.46924 6.00004 7.99967C6.00004 8.53011 6.21075 9.03882 6.58583 9.41389C6.9609 9.78896 7.46961 9.99967 8.00004 9.99967C8.53047 9.99967 9.03918 9.78896 9.41425 9.41389C9.78933 9.03882 10 8.53011 10 7.99967C10 7.46924 9.78933 6.96053 9.41425 6.58546C9.03918 6.21039 8.53047 5.99967 8.00004 5.99967Z"
                        fill="#11273E"
                      />
                    </svg>
                  </a>

                  <a
                    v-if="branch.linkedin"
                    :href="branch.linkedin"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white !tw-p-0"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.62663 3.33302C4.62645 3.68665 4.48581 4.02571 4.23563 4.27564C3.98546 4.52556 3.64625 4.66587 3.29263 4.66569C2.93901 4.66551 2.59994 4.52487 2.35001 4.27469C2.10009 4.02452 1.95978 3.68531 1.95996 3.33169C1.96014 2.97807 2.10078 2.639 2.35096 2.38908C2.60113 2.13915 2.94034 1.99885 3.29396 1.99902C3.64758 1.9992 3.98665 2.13985 4.23658 2.39002C4.4865 2.64019 4.6268 2.9794 4.62663 3.33302ZM4.66663 5.65302H1.99996V13.9997H4.66663V5.65302ZM8.87996 5.65302H6.22663V13.9997H8.85329V9.61969C8.85329 7.17969 12.0333 6.95302 12.0333 9.61969V13.9997H14.6666V8.71302C14.6666 4.59969 9.95996 4.75302 8.85329 6.77302L8.87996 5.65302Z"
                        fill="#11273E"
                      />
                    </svg>
                  </a>
                  <a
                    v-if="branch.youtube"
                    :href="branch.youtube"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white !tw-p-0"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1287_50)">
                        <path
                          d="M8.00004 2.66699C8.57004 2.66699 9.15471 2.68166 9.72137 2.70566L10.3907 2.73766L11.0314 2.77566L11.6314 2.81633L12.1794 2.85899C12.7741 2.90451 13.3337 3.15829 13.7597 3.57569C14.1858 3.99308 14.451 4.54735 14.5087 5.14099L14.5354 5.42433L14.5854 6.03099C14.632 6.65966 14.6667 7.34499 14.6667 8.00033C14.6667 8.65566 14.632 9.34099 14.5854 9.96966L14.5354 10.5763C14.5267 10.6737 14.518 10.7677 14.5087 10.8597C14.451 11.4534 14.1857 12.0078 13.7595 12.4252C13.3333 12.8426 12.7735 13.0963 12.1787 13.1417L11.632 13.1837L11.032 13.225L10.3907 13.263L9.72137 13.295C9.14793 13.3199 8.57403 13.3328 8.00004 13.3337C7.42606 13.3328 6.85215 13.3199 6.27871 13.295L5.60937 13.263L4.96871 13.225L4.36871 13.1837L3.82071 13.1417C3.22601 13.0961 2.66641 12.8424 2.24036 12.425C1.8143 12.0076 1.54909 11.4533 1.49137 10.8597L1.46471 10.5763L1.41471 9.96966C1.36373 9.31442 1.3366 8.65754 1.33337 8.00033C1.33337 7.34499 1.36804 6.65966 1.41471 6.03099L1.46471 5.42433C1.47337 5.32699 1.48204 5.23299 1.49137 5.14099C1.54907 4.54746 1.81419 3.99327 2.2401 3.57589C2.66602 3.15851 3.22546 2.90466 3.82004 2.85899L4.36737 2.81633L4.96737 2.77566L5.60871 2.73766L6.27804 2.70566C6.85171 2.68075 7.42583 2.66786 8.00004 2.66699ZM8.00004 4.00033C7.45004 4.00033 6.88404 4.01499 6.33337 4.03766L5.68137 4.06899L5.05537 4.10566L4.46737 4.14566L3.92871 4.18766C3.64559 4.20775 3.37874 4.32742 3.17544 4.52548C2.97214 4.72353 2.84552 4.98717 2.81804 5.26966C2.74004 6.07566 2.66671 7.07899 2.66671 8.00033C2.66671 8.92166 2.74004 9.92499 2.81804 10.731C2.87471 11.3123 3.33604 11.7643 3.92871 11.813L4.46737 11.8543L5.05537 11.8943L5.68137 11.9317L6.33337 11.963C6.88404 11.9857 7.45004 12.0003 8.00004 12.0003C8.55004 12.0003 9.11604 11.9857 9.66671 11.963L10.3187 11.9317L10.9447 11.895L11.5327 11.855L12.0714 11.813C12.3545 11.7929 12.6213 11.6732 12.8246 11.4752C13.0279 11.2771 13.1546 11.0135 13.182 10.731C13.26 9.92499 13.3334 8.92166 13.3334 8.00033C13.3334 7.07899 13.26 6.07566 13.182 5.26966C13.1546 4.98717 13.0279 4.72353 12.8246 4.52548C12.6213 4.32742 12.3545 4.20775 12.0714 4.18766L11.5327 4.14633L10.9447 4.10633L10.3187 4.06899L9.66671 4.03766C9.11147 4.01377 8.55579 4.00132 8.00004 4.00033ZM6.66671 6.38366C6.66666 6.3185 6.68254 6.25432 6.71295 6.19669C6.74336 6.13907 6.78739 6.08975 6.84121 6.05302C6.89503 6.01628 6.957 5.99325 7.02175 5.98593C7.08649 5.97861 7.15204 5.98721 7.21271 6.01099L7.26671 6.03766L10.0667 7.65366C10.1225 7.68583 10.1696 7.73098 10.2042 7.78528C10.2388 7.83958 10.2597 7.90143 10.2653 7.96556C10.2709 8.02969 10.2609 8.09422 10.2362 8.15366C10.2114 8.2131 10.1728 8.2657 10.1234 8.30699L10.0667 8.34699L7.26671 9.96366C7.21028 9.99633 7.14672 10.0147 7.08157 10.0172C7.01642 10.0197 6.95164 10.0062 6.89288 9.97798C6.83412 9.94972 6.78316 9.90752 6.74444 9.85506C6.70571 9.8026 6.6804 9.74147 6.67071 9.67699L6.66671 9.61699V6.38366Z"
                          fill="#11273E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1287_50">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <h4 v-if="branch.office_hours[1].value" class="!tw-text-lg">Opening Hours</h4>
              <template v-if="branch.office_hours[1].value">
                <div
                  v-for="(officeHour, officeHourIndex) in branch.office_hours"
                  :key="`${officeHour.title}-${index}-${officeHourIndex}`"
                  class="tw-flex tw-flex-row tw-justify-between"
                >
                  <div v-if="officeHour.value">{{ officeHour.title }}</div>
                  <div v-if="officeHour.value">
                    {{ officeHour.value }}
                  </div>
                </div>
              </template>
              <div v-if="branch.general_office_hour" class="tw-mt-4">
                {{ branch.general_office_hour }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MotionGroup>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'BranchesContact',

  mixins: [ComponentMixin],

  computed: {
    branches() {
      const branches = this.groupedVariables.branches;
      if (branches && branches.length) {
        return branches.map((branch) => {
          return {
            ...branch,
            office_hours: [
              {
                title: 'Monday',
                value: branch.monday,
              },
              {
                title: 'Tuesday',
                value: branch.tuesday,
              },
              {
                title: 'Wednesday',
                value: branch.wednesday,
              },
              {
                title: 'Thursday',
                value: branch.thursday,
              },
              {
                title: 'Friday',
                value: branch.friday,
              },
              {
                title: 'Saturday',
                value: branch.saturday,
              },
              {
                title: 'Sunday',
                value: branch.sunday,
              },
            ],
          };
        });
      }
      return [];
    },
  },
});
</script>
